/**
 *
 * @param {*} bankCode Unique code from bank gotten from CBN
 * @param {*} accountNumber The user account Number
 * @method {*} validate the property passed in
 */

function ValidateNuban(bankCode, accountNumber) {
    var checkDigit = accountNumber.charAt(9);
    var dictionary = [3, 7, 3, 3, 7, 3, 3, 7, 3, 3, 7, 3];
    var accountSerialNo = accountNumber.substring(0, 9);
    var nubanAccountFormat = bankCode + accountSerialNo;

    var checkSum = 0;

    nubanAccountFormat.split('').forEach(function (char, index) {
        checkSum += char * dictionary[index];
    });

    var validatedCheckDigit = 10 - (checkSum % 10);
    // eslint-disable-next-line eqeqeq
    validatedCheckDigit = validatedCheckDigit == 10 ? 0 : validatedCheckDigit;

    // eslint-disable-next-line eqeqeq
    return checkDigit == validatedCheckDigit ? '' : 'This Account does not exist with this bank';
}

export default ValidateNuban;
